import { IconAlertTriangle } from '@iwoca/icons';

import { useGetSecurityCheckRequirements } from './useGetSecurityCheckRequirements';

export const SecurityChecksPrompt = () => {
  const { isAnyRequirementVisible, loadingFundingRequirement } =
    useGetSecurityCheckRequirements();

  if (loadingFundingRequirement) return null;
  if (!isAnyRequirementVisible) return null;

  return (
    <div className="mb-l flex rounded-xs border border-core-90 bg-core-95 p-s">
      <div className="mr-s shrink-0">
        <IconAlertTriangle className="mt-2xs h-[24px] w-[24px] shrink-0 fill-[#C70E04]" />
      </div>
      <div>
        <div className="text-s font-bold">
          You still need to finish your security checks before you can use your
          spending limit
        </div>
        <div className="text-s font-reg">
          Once they're done you'll be able to use your spending limit to finish
          your purchase.
        </div>
      </div>
    </div>
  );
};
